import { render, staticRenderFns } from "./otherAudit.vue?vue&type=template&id=0dc7f62a&scoped=true&"
import script from "./otherAudit.vue?vue&type=script&lang=js&"
export * from "./otherAudit.vue?vue&type=script&lang=js&"
import style0 from "./otherAudit.vue?vue&type=style&index=0&id=0dc7f62a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc7f62a",
  null
  
)

export default component.exports